import { Col, Row } from "antd";
import { showError } from "common/ToastNotifications";
import { JdbcTableList, LoadingOverlay } from "components";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

class SystemConnectionJdbcTables extends Component {
    constructor(props) {
        super(props);
        this.state = {
            busyMessage: "",
            fetchingTables: false,
            permissionDenied: false,
            selectedTableName: "",
        };
    }

    componentWillMount() {
        this.setState({
            fetchingTables: true,
        });
        this.props.getJdbcConnectionTables(this.props.connectionId);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetJdbcConnectionTablesResultUpdate(prevProps);
        const prevPreview = prevProps.getJdbcTablePreviewResult;
        const nextPreview = this.props.getJdbcTablePreviewResult;
        if (prevPreview !== nextPreview) {
            this.setState({ fetchingTables: false });
            if (nextPreview && nextPreview.success) {
                const rows = this.props.jdbcTablePreview;
                const columns = rows.length ? Object.keys(rows[0]) : [];
                const tableName = this.state.selectedTableName.Name;
                this.props.onTableSelected({ data: rows, columns, tableName });
            } else if (nextPreview && !nextPreview.success) {
                showError(nextPreview.message || "Failed to load table preview.");
            }
        }
    }

    onGetJdbcConnectionTablesResultUpdate = (prevProps) => {
        if (this.props.getJdbcConnectionTablesResult && this.props.getJdbcConnectionTablesResult !== prevProps.getJdbcConnectionTablesResult) {
            if (!this.props.getJdbcConnectionTablesResult.success) {
                if (this.props.getJdbcConnectionTablesResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true,
                    });
                } else {
                    showError("Could not get JDBC connection tables at this moment.");
                }
            }
            this.setState({
                fetchingTables: false,
            });
        }
    };

    handleTableClick = (tableName) => {
        if (!tableName) return;
        this.setState({ fetchingTables: true, selectedTableName: tableName });
        this.props.getJdbcTablePreview(this.props.connectionId, tableName, 10);
        this.props.getJdbcTableSchema(this.props.connectionId, tableName);
    };

    render() {
        return (
            <Row style={{ flexDirection: "column", flexGrow: 1, height: "100%" }}>
                <Col span={24} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    <LoadingOverlay busy={this.state.fetchingTables} spinner message={this.state.busyMessage || "Please wait..."}></LoadingOverlay>
                    <JdbcTableList tables={this.props.jdbcConnectionTables} onTableSelected={this.handleTableClick}></JdbcTableList>
                    {this.props.jdbcTableSchema && this.props.jdbcTableSchema.length > 0 && (
                        <div style={{ marginTop: 24 }}>
                            <h3>Table Schema</h3>
                            <pre style={{ background: "#f6f6f6", padding: 16, borderRadius: 4 }}>{JSON.stringify(this.props.jdbcTableSchema, null, 2)}</pre>
                        </div>
                    )}
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getJdbcConnectionTablesResult: state.systemConnectionJdbc.getJdbcConnectionTablesResult,
        jdbcConnectionTables: state.systemConnectionJdbc.jdbcConnectionTables,
        getJdbcTablePreviewResult: state.systemConnectionJdbc.getJdbcTablePreviewResult,
        jdbcTablePreview: state.systemConnectionJdbc.jdbcTablePreview,
        jdbcTableSchema: state.systemConnectionJdbc.jdbcTableSchema,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getJdbcConnectionTables: (connectionId) => dispatch(actions.getJdbcConnectionTablesRequest(connectionId)),
        getJdbcTablePreview: (connectionId, tableName, limit) => dispatch(actions.getJdbcTablePreviewRequest(connectionId, tableName, limit)),
        getJdbcTableSchema: (connectionId, tableName) => dispatch(actions.getJdbcTableSchemaRequest(connectionId, tableName)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SystemConnectionJdbcTables));
